import styled from "styled-components";

import { colors, radii } from "shared/ui";

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
`;


export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;


export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    background: ${colors.surface};
`;


export const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;


export const Name = styled.div`
    font-weight: 600;
    overflow-wrap: break-word;
`;


export const Meta = styled.div`
    color: ${colors.textSecondary};
    font-size: 13px;
`;


export const RowActions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    @media (max-width: 700px) {
        flex-direction: column;
        /* Текстовая кнопка кита по высоте равна тексту — без зазора две подряд слипаются. */
        align-items: flex-end;
        gap: 8px;
    }
`;


export const StopListMark = styled.span`
    color: ${colors.danger};
`;


export const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${colors.textPrimary};
`;
